/* DndEditor — one row inside the Notifications group.
 *
 * Text left, action right, matching the left-label/right-control rhythm of
 * the OS/Call notification toggle rows it sits beneath. The pre-declutter
 * card (a `--bg-secondary` panel wrapping a full-width primary button) was
 * the loudest element on the page and read as a container nested inside a
 * section; this row carries the same 12/16 inset every settings row owns.
 */

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-12);
  padding: 0 var(--spacing-16) var(--spacing-12);
}

/* Takes the slack so the button stays hard-right; `min-width: 0` lets long
 * translations wrap instead of pushing the button past the panel edge. */
.rowText {
  flex: 1;
  min-width: 0;
  margin: 0;
}
